export const TOKEN_KEY = 'admin_token';
export const API_BASE = process.env.REACT_APP_BASE_URL || '/api';
